import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, SubmitHandler } from 'react-hook-form';
import Textarea from '../../Forms/Textarea'; // Adjust path if needed

interface AddCommentFormInputs {
  content: string;
}

interface AddCommentFormProps {
  onSubmit: (content: string) => Promise<void>;
  isLoading?: boolean;
  onCancel?: () => void;
}

const AddCommentForm: React.FC<AddCommentFormProps> = ({ onSubmit, isLoading = false, onCancel }) => {
  const { t } = useTranslation();
  const { register, handleSubmit, reset, formState: { errors } } = useForm<AddCommentFormInputs>();

  const handleFormSubmit: SubmitHandler<AddCommentFormInputs> = async (data) => {
    await onSubmit(data.content);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="mt-6">
      <Textarea
        label={t('useCaseDiscussion.addComment')}
        id="comment-content"
        name="content"
        register={register}
        rules={{ required: t('useCaseDiscussion.commentRequired') }}
        error={errors.content}
        rows={4}
        placeholder={t('useCaseDiscussion.commentPlaceholder')}
        disabled={isLoading}
      />
      <div className="mt-3 flex justify-end gap-2">
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="inline-flex items-center px-4 py-2 border border-input text-sm font-medium rounded-md shadow-sm bg-background text-foreground hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          >
            {t('global.cancel')}
          </button>
        )}
        <button
          type="submit"
          disabled={isLoading}
          className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-background ${
            isLoading
              ? 'bg-primary/50 cursor-not-allowed'
              : 'bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2'
          }`}
        >
          {isLoading ? t('useCaseDiscussion.sending') : t('global.send')}
        </button>
      </div>
    </form>
  );
};

export default AddCommentForm;
